// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponCreateProgress_root__kWx1q","progress":"CouponCreateProgress_progress__H_2H_","small":"CouponCreateProgress_small__mndfc","large":"CouponCreateProgress_large__zDcS4"};